@if (footerData) {
<footer class="footer" role="contentinfo" aria-label="Pie de página">

  <div class="footer__header">

    <div class="footer__logos">
      @for (logo of footerData.logos; track $index) {
      <img [src]="getImageUrl(logo.image.url)" [alt]="logo.alt" [style.height.px]="logo.height" class="footer__logo" />
      }
    </div>

    @if (footerData.socialLinks?.length) {
    <div class="footer__social">
      @for (social of footerData.socialLinks; track $index) {
      <a [href]="social.url" target="_blank" rel="noopener noreferrer"
        [attr.aria-label]="'Visitar ' + social.platform + ' (se abre en ventana nueva)'">
        <img [src]="'/assets/images/' + social.platform.toLowerCase() + '.svg'" [alt]="social.platform"
          aria-hidden="true" class="footer__social-icon" />
      </a>
      }
    </div>
    }

  </div>

  <div class="footer__columns">
    @for (column of footerData.footerColumn; track column.id) {
    @if (column.links.length) {

    <div class="footer__column">

      <h3 class="footer__title body3-medium">
        {{ column.name }}
      </h3>

      <ul class="footer__list" [attr.aria-label]="column.name">

        @for (link of getValidLinks(column.links); track $index) {
        <li class="footer__item">

          @if (!link.isExternal) {
          <a [routerLink]="link.url" class="footer__link body2-regular" [attr.aria-label]="link.name">
            {{ link.name }}
          </a>
          } @else {
          <a [href]="link.url" class="footer__link body2-regular" target="_blank" rel="noopener noreferrer"
            [attr.aria-label]="link.name + ' (se abre en ventana nueva)'">
            {{ link.name }}
            <span class="material-symbols-outlined footer__icon" aria-hidden="true">
              {{ externalIcon }}
            </span>
          </a>
          }

        </li>
        }

      </ul>

    </div>

    }
    }
  </div>

  @if (footerData.legalLinks?.length) {
  <div class="footer__legal">
    @for (link of footerData.legalLinks; track $index) {
    <a [routerLink]="link.url" class="body2-regular">{{ link.name }}</a>
    }
  </div>
  }

  <div class="footer__bottom">

    <p class="footer__copyright body3-regular">
      {{ footerData.copyright }}
    </p>

    @if (footerData.accessibilityBadge) {
    <img [src]="getImageUrl(footerData.accessibilityBadge.image.url)"
      [alt]="footerData.accessibilityBadge.alt || 'Certificación accesibilidad'" class="footer__accessibilityBadge" />
    }

  </div>

</footer>
}